import { useState, useEffect } from 'react'

const useMode = () => {
    const [theme, setTheme] = useState(
        JSON.parse(localStorage.getItem("theme")) 
        ? JSON.parse(localStorage.getItem("theme"))
        : 'default'
        );
    const toggleTheme = (newTheme) => {
        if(theme !== newTheme){
            setTheme(newTheme)
            localStorage.setItem('theme', JSON.stringify(newTheme))
        }
    }
    useEffect(() => {
        localStorage.getItem('theme')
        &&
        setTheme(JSON.parse(localStorage.getItem('theme')))
    }, [])
    return {theme, toggleTheme}
}
export default useMode